<template>
  <v-container fluid class="deleted-invoice-page pa-0">
    <v-card :loading="loading" outlined class="deleted-invoice-card">
      <div class="list-header">
        <div class="title-wrap">
          <v-btn icon small class="mr-2" @click="$router.go(-1)">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>

          <div>
            <div class="page-title">Deleted Invoices</div>
            <div class="page-subtitle">
              {{ Invoices.length }} invoice{{ Invoices.length === 1 ? "" : "s" }} found
            </div>
          </div>
        </div>
      </div>

      <div class="filter-bar">
        <v-text-field
          v-model="search"
          outlined
          prepend-inner-icon="mdi-magnify"
          dense
          label="Search invoices"
          single-line
          hide-details
          clearable
          class="search-field"
        />

        <v-spacer />

        <DateTimePicker
          defaultRange="since30DaysAgo"
          :range="true"
          v-model="dateTime"
          @submit="getList()"
        />
      </div>

      <v-card-text class="pa-4">
        <v-data-table
          :mobile-breakpoint="0"
          :headers="headers"
          :items="Invoices"
          :search="search"
          :loading="loading"
          :sort-desc="sortDesc"
          :sort-by="sortBy"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          class="deleted-invoice-table"
        >
          <template v-slot:item="{ item }">
            <tr class="pointer table-row">
              <td class="text-left" @click="viewInvoice(item)">
                <div class="invoice-created-cell">
                  <div class="invoice-created-date">
                    {{ item.createdAt | moment("MM/DD/YYYY") }}
                  </div>
                  <div class="invoice-created-time">
                    {{ item.createdAt | moment("hh:mm A") }}
                  </div>
                </div>
              </td>

              <td class="text-left" @click="viewInvoice(item)">
                <div class="deleted-at-cell">
                  <v-chip small color="red lighten-5" text-color="red darken-3" class="font-weight-bold">
                    {{ item.deletedAt | moment("MM/DD/YYYY") }}
                  </v-chip>
                  <div class="deleted-at-time">
                    {{ item.deletedAt | moment("hh:mm A") }}
                  </div>
                </div>
              </td>

              <td class="text-left" @click="viewInvoice(item)">
                <div v-if="item.DeletedBy && item.DeletedBy.name" class="deleted-by-cell">
                  <v-avatar size="28" color="blue lighten-5" class="mr-2">
                    <v-icon small color="primary">mdi-account-outline</v-icon>
                  </v-avatar>
                  <span>{{ item.DeletedBy.name }}</span>
                </div>
                <span v-else class="deleted-by-unknown">Not recorded</span>
              </td>

              <td class="text-left font-weight-bold" @click="viewInvoice(item)">
                {{ item.localId }}
              </td>

              <td class="text-left" @click="viewInvoice(item)">
                {{ item.Customer && item.Customer.name ? item.Customer.name : "--" }}
              </td>

              <td class="text-right font-weight-bold" @click="viewInvoice(item)">
                {{ item.total | currency }}
              </td>

              <td class="text-right font-weight-bold" @click="viewInvoice(item)">
                {{ item.due | currency }}
              </td>

              <td class="text-right">
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" icon small>
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list dense class="menu-button">
                    <v-list-item @click="viewInvoice(item)">
                      <v-list-item-title>View Invoice</v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="viewPackingSlip(item)">
                      <v-list-item-title>View Packing Slip</v-list-item-title>
                    </v-list-item>

                    <v-divider />

                    <v-list-item @click="openHistory(item)">
                      <v-list-item-title>View History</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </template>

          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </v-card-text>
    </v-card>

    <InvoiceHistoryDialog
      v-show="historyDialog"
      v-model="historyDialog"
      :invoice="historyInvoice"
    />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

import invoiceService from "../service";
import InvoiceHistoryDialog from "@/modules/Invoice/components/InvoiceHistoryDialog.vue";
// import InvoiceViewLink from "./InvoiceViewLink";
const DateTimePicker = () => import("@/components/DateTimePicker");
import Hashids from "hashids";
const hashids = new Hashids();

export default {
  name: "invoice-list",
  data() {
    return {
      fab: false,
      historyDialog: false,
      historyInvoice: null,
      dateTime: {
        start: this.$moment().startOf("day").toISOString(),
        end: this.$moment().endOf("day").toISOString(),
      },
      createDialog: false,
      selectedPayee: null,
      headers: [],
      Invoices: [],
      search: null,
      loading: true,
      page: 1,
      sortBy: "localId",
      pageCount: 0,
      sortDesc: true,
      itemsPerPage: 10,
    };
  },
  created() {
    this.getList();
    this.loadHeader();
    this.$events.listen("invoiceListEvent", () => this.getList());
    document.title = "smplsale - Invoice List";
  },
  beforeDestroy() {
    this.$events.remove("invoiceListEvent");
  },
  components: {
    DateTimePicker,
    InvoiceHistoryDialog,
    // InvoiceViewLink
  },
  computed: {
    ...mapGetters("global", [
      "currentUser",
      "checkRightStatus",
      "currentBusiness",
    ]),
  },
  methods: {
    openHistory(invoice) {
      if (!this.currentBusiness.metadata.historyTracking) {
        this.$swal({
          icon: "warning",
          title: "History Tracking Off",
          text: "Enable it in Settings to view change logs ($50/month).",
        });
        return;
      }

      this.historyInvoice = invoice;
      this.historyDialog = true;
    },
    viewProfile(val) {
      this.$router.push({ path: `/customer/${val.CustomerId}/profile` });
    },
    viewInvoice(invoice) {
      const hashId = hashids.encode(invoice.id);
      const createdLink = `/global/invoice/deleted/${hashId}/view`;
      // console.log('createdLink', createdLink)
      const routeData = this.$router.resolve({
        path: createdLink,
      });
      // this.$router.push({ path: `/global/invoice/deleted/${hashId}/view` });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    viewPackingSlip(invoice) {
      const hashId = hashids.encode(invoice.id);
      const routeData = this.$router.resolve({
        path: `/global/invoice/deleted/${hashId}/packingSlip`,
      });
      window.open(routeData.href, "newwindow", "width=850, height=1100");
    },
    loadHeader() {
      this.headers = [];
      this.headers.push({
        text: "Created At",
        align: "left",
        value: "createdAt",
        sortable: true,
      });

      this.headers.push({
        text: "Deleted At",
        align: "left",
        value: "deletedAt",
        sortable: true,
      });

      this.headers.push({
        text: "Deleted By",
        align: "left",
        value: "DeletedBy.name",
        sortable: false,
      });

      this.headers.push({
        text: "Invoice Number",
        align: "left",
        value: "localId",
        sortable: true,
      });

      this.headers.push({
        text: "Customer Name",
        value: "Customer.name",
        align: "left",
        sortable: true,
      });

      // this.headers.push({
      //   text: "Note",
      //   align: "left",
      //   value: "note",
      //   sortable: true
      // });

      this.headers.push({
        text: "Total",
        value: "total",
        align: "right",
        sortable: true,
      });

      // this.headers.push({
      //   text: "Payment",
      //   value: "payment",
      //   align: "right",
      //   sortable: true
      // });
      this.headers.push({
        text: "Balance",
        value: "due",
        align: "right",
        sortable: true,
      });
      this.headers.push({
        text: "",
        value: "action",
        sortable: false,
      });
    },
    getList() {
      this.loading = true;
      let where = {
        start: this.dateTime.start,
        end: this.dateTime.end,
      };
      where.deleted = true;
      // if (this.CustomerId) {
      //   where.CustomerId = this.CustomerId;
      // }

      // if (this.due) {
      //   where.due = true;
      // }

      return invoiceService.getAll(where).then((response) => {
        // // console.log("invoice", response);
        this.loading = false;
        this.Invoices = response.data;
        return response;
      });
    },
    editInvoice(invoice) {
      // // console.log('ddf', invoice)
      this.$router.push({ path: `/customer/invoice/${invoice.id}/edit` });
    },
    deleteInvoice(invoice) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          invoiceService
            .delete(invoice.id)
            .then((response) => {
              if (response.data) {
                this.$swal("Deleted!", "Invoice has been deleted.", "success");
                this.getList();
                this.$events.emit("customerProfileEvent");
              }
            })
            .catch((error) => {
              this.$swal({
                title: "Delete Invoice",
                text: error.data.message,
                type: "error",
              });
            });
        }
      });
    },
  },
};
</script>

<style scoped>
.deleted-invoice-page {
  background: #f8fafc;
  min-height: 100vh;
}

.deleted-invoice-card {
  border-radius: 20px;
  background: #ffffff;
  overflow: hidden;
}

.list-header {
  padding: 16px;
  border-bottom: 1px solid #e2e8f0;
}

.title-wrap {
  display: flex;
  align-items: center;
}

.page-title {
  font-size: 22px;
  font-weight: 900;
  color: #0f172a;
  line-height: 1.15;
}

.page-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 3px;
}

.filter-bar {
  padding: 12px 16px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.search-field {
  max-width: 360px;
  min-width: 260px;
}

.deleted-invoice-table {
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
}

.table-row:hover {
  background: #f8fafc;
}

.deleted-at-cell {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  padding: 6px 0;
}

.invoice-created-cell {
  display: inline-flex;
  flex-direction: column;
  gap: 3px;
  padding: 6px 0;
}

.invoice-created-date {
  color: #334155;
  font-weight: 700;
}

.invoice-created-time {
  color: #64748b;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
}

.deleted-at-time {
  color: #64748b;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
}

.deleted-by-cell {
  display: flex;
  align-items: center;
  color: #334155;
  font-weight: 700;
  white-space: nowrap;
}

.deleted-by-unknown {
  color: #94a3b8;
  font-size: 12px;
  font-style: italic;
}

@media (max-width: 600px) {
  .page-title {
    font-size: 20px;
  }

  .search-field {
    max-width: none;
    min-width: 0;
    width: 100%;
  }

  .filter-bar {
    padding: 10px;
  }
}
</style>
